import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Featured from './components/Featured';
import CategorySection from './components/CategorySection';
import Ranking from './components/Ranking';
import Guide from './components/Guide';
import Faq from './components/Faq';
import About from './components/About';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <CategorySection category="校园" />
        <CategorySection category="同居" />
        <CategorySection category="暧昧" />
        <CategorySection category="逆后宫" />
        <Ranking />
        <Guide />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}